// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_p-9","cls2":"WorkCard-cls2_4xC WorkCard-cls1_p-9"};